import axiosInstance from "../../../../../services/axiosInstance";
// import { API_BASE_URL } from "../utils/constants";
const API_BASE_URL = process.env.REACT_APP_JUSTTAWK_IND_BASE_API_URL;

// Deals API
export const dealsAPI = {
  getAll: (userId, params) => axiosInstance.get(`/deals/${userId}`, { params }),
  create: (data) => axiosInstance.post(`/deals`, data),
  update: (id, data) => axiosInstance.put(`/deals/${id}`, data),
  delete: (id) => axiosInstance.delete(`/deals/${id}`),

  getSingleLead: (id) => axiosInstance.get(`/deals/single-deal/${id}`),
  bulkCreate: (data) => axiosInstance.post(`/deals/bulk`, data),
};

// Stages API
export const stagesAPI = {
  getAll: (userId, params) => axiosInstance.get(`/stages/${userId}`, { params }),
  create: (data) => axiosInstance.post(`/stages`, data),
  update: (id, data) => axiosInstance.put(`/stages/${id}`, data),
  delete: (id) => axiosInstance.delete(`/stages/${id}`),
};

// Companies API
export const companiesAPI = {
  getAll: (userId) => axiosInstance.get(`/companies/${userId}`),
  create: (data) => axiosInstance.post(`/companies`, data),
};

// Contacts API
export const contactsAPI = {
  getAll: (userId) => axiosInstance.get(`/contacts/${userId}`),
  create: (data) => axiosInstance.post(`/contacts`, data),
};

// Notes API
export const notesDealAPI = {
  addNotes: () => axiosInstance.post(`/deals/notes`),
  getNotes: (dealId) => axiosInstance.get(`/notes/${dealId}`),
};

// Appointments API
export const appointmentsAPI = {
  getAll: (params) => axiosInstance.get(`/appointments`, { params }),
};
